export const RedirectObjectId = 'Redirect';

export enum RedirectObjectAttributes {
  SOURCE = 'source',
  TARGET = 'target',
}
